// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.expertMiniInfo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.85rem;
  padding: 1.25rem 1.25rem 0.75rem;
}
.expertMiniInfo .avatarWrap {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  overflow: hidden;
  background-color: rgba(81, 85, 146, 0.1);
  border-radius: 50%;
}
.expertMiniInfo .avatarWrap .avatar {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.expertMiniInfo .avatarWrap .avatarInitials {
  font-weight: 600;
  font-size: 1.1rem;
  color: #515592;
}
.expertMiniInfo .expertDescr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}
.expertMiniInfo .title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.expertMiniInfo .profession {
  margin: 0.1rem 0 0;
  color: rgb(80, 80, 80);
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/ExpertInfoMini/ExpertInfoMini.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;AAqEF;AAnEE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;AAqEJ;AAnEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAqEN;AAlEI;EACE,gBAAA;EACA,iBAAA;EACA,cA/BU;AAmGhB;AAhEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAkEJ;AA/DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAiEJ;AA9DE;EACE,kBAAA;EACA,sBC/Ca;EDgDb,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAgEJ","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme/';\n\n$brand_primary: #515592;\n\n.expertMiniInfo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.25rem 1.25rem 0.75rem;\n\n  .avatarWrap {\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    width: 3.5rem;\n    height: 3.5rem;\n    overflow: hidden;\n    background-color: rgba(81, 85, 146, 0.1);\n    border-radius: 50%;\n\n    .avatar {\n      border-radius: 50%;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      display: block;\n    }\n\n    .avatarInitials {\n      font-weight: 600;\n      font-size: 1.1rem;\n      color: $brand_primary;\n    }\n  }\n\n  .expertDescr {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 0;\n  }\n\n  .title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 700;\n    color: #222;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .profession {\n    margin: 0.1rem 0 0;\n    color: $unselectedText;\n    font-size: 0.8rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
